import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_downgrade_to_lite = _resolveComponent("downgrade-to-lite")!

  return (_openBlock(), _createBlock(_component_downgrade_to_lite, {
    "lost-benefits": _ctx.lostBenefits,
    "subscription-id": _ctx.subscriptionId,
    "last-quote": _ctx.lastQuote,
    "is-quoting": _ctx.isQuoting,
    onClearQuote: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearQuote'))),
    onRequestQuote: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('requestQuote', $event)))
  }, null, 8, ["lost-benefits", "subscription-id", "last-quote", "is-quoting"]))
}